import axios from 'axios';
import { Message as $message, MessageBox } from 'element-ui';
import store from '../store';
// import { getToken } from '@/utils/auth';
import { parseUrlSearch } from '@/utils/index';
import qs from "qs";

// axios.defaults.withCredentials = true;
// 创建axios实例
const service = axios.create({
    withCredentials: true,
    baseURL: process.env.BASE_API, // api的base_url
    timeout: 150000000 // 请求超时时间
});

let cookieInfo = {};
// request拦截器


service.interceptors.request.use(config => {
    // console.log(cookieInfo);
    // config.params.userId = cookieInfo.userId
    // config.data.userId = cookieInfo.userId
    // if(getToken()) {
    //     cookieInfo = JSON.parse(getToken());
    // }
    // if (store.getters.token) {
    //   config.headers['token'] = cookieInfo.token // 让每个请求携带自定义token 请根据实际情况自行修改
    // }
    // if(config.method === "post") {
    //   config.data.userId = cookieInfo.userId
    //   config.data = qs.stringify(config.data);
    // } else {
    //   config.params.userId = cookieInfo.userId
    // }

    // if (store.getters.token) {
    //   config.headers['token'] = getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
    // }
    config.headers['channel'] = 1;
    if (config.method === "post") {
        config.data = qs.stringify(config.data);
    }
    return config;
}, error => {
    console.log(error); // for debug
    return Promise.reject(error);
});

// response 拦截器
service.interceptors.response.use(
    response => {
        // code为非20000是抛错 可结合自己业务进行修改
        const res = response.data
        if (res.successed === false) {
            $message.error(res.errorDesc || '系统错误');
            return Promise.reject('error');
        } else {
            return response.data;
        }
    },
    error => {
        $message.error(error.message);
        return Promise.reject(error);
    }
);

export default service;


/**
 * 上传文件（支持多个文件）
 * @param {string} url 接口路径
 * @param {File | File[]} files 单个或多个文件对象，File可以是 Blob 对象
 * @param [options]
 * @param {string} [options.name] 文件表单项的 name
 * @param {object} [options.headers] 自定义请求头
 * @param {function} [options.onUploadProgress] 上传进度的监听函数
 * */
export function uploadFile(url, files, options = {}) {
    let errMsg = '';
    if (!url) {
        errMsg = '接口地址不能为空';
        $message.error(errMsg);
        return Promise.reject(errMsg);
    }

    if (!files || (Array.isArray(files) && !files.length)) {
        errMsg = '请选择文件';
        $message.error(errMsg);
        return Promise.reject(errMsg);
    }

    const token = store.state.user.token; // 注意：广告主后台没有返回 token 值
    // 处理 url 参数
    const query = Object.entries({
        ...parseUrlSearch(url),
        token: token,
    }).map(([key, value]) => `${key}=${value}`).join('&');
    // 完整的请求 url
    const domain = !/^https?:/.test(url) ? process.env.BASE_API : '';
    const serverUrl = `${ domain }${ url.replace(/\?.*/, '') }?${ query }`;
    // 表单数据对象
    const formData = new FormData();
    // 文件表单项的 name
    const fileFieldName = options.name || 'file';
    // 表单头
    const headers = {
        'Content-Type': 'multipart/form-data',
        'token': token,
    };

    if (options.headers) {
        Object.assign(headers, options.headers);
    }

    // Content-Disposition: form-data; name="file"; filename="300x300.png"
    if (Array.isArray(files)) {
        files.forEach((file, index) => {
            // 多个文件时，filename 不能重复
            formData.append(fileFieldName + (index ? index + 1 : ''), file, file.name);
        });
    } else {
        formData.append(fileFieldName, files, files.name);
    }

    return new Promise((resolve, reject) => {
        const ops = {
            headers,
            onUploadProgress: options.onUploadProgress,
        };
        axios.post(serverUrl, formData, ops).then(response => {
            const res = response.data || {};
            if (!res) {
                const errMsg = '上传失败';
                $message.error(errMsg);
                reject(errMsg);
            } else {
                // 每个接口返回的结果可能不同，需自行处理
                resolve(res);
            }
        }).catch(err => {
            $message.error(err.message);
            reject(err);
        })
    })
}



// WEBPACK FOOTER //
// ./src/utils/request.js